/* eslint-disable @typescript-eslint/only-throw-error */
import { type LoaderFunction, matchPath, replace } from 'react-router'
import type { WaitForAuthResolutionFn } from '@/features/iam'
import type { ShellFeature } from '@/features/shell'
import { links } from '@/utils/link'

/**
 * Options for {@link createShellLoader}.
 */
export interface CreateShellLoaderOptions {
  shell: ShellFeature
  waitForAuthResolution: WaitForAuthResolutionFn
}

/**
 * Creates a loader for the shell that keeps call agents in the call center.
 *
 * @param options
 */
export function createShellLoader(
  options: CreateShellLoaderOptions,
): LoaderFunction {
  return async ({ request }) => {
    const { workspace } = await options.waitForAuthResolution(request.signal)
    if (!workspace || !options.shell.internal.globalNavigationVm.isCallAgent) {
      return null
    }

    const { pathname } = new URL(request.url)
    const isAllowed =
      matchPath('/logout/*', pathname) ??
      matchPath({ path: links.callCenter(), end: false }, pathname)
    if (!isAllowed) {
      throw replace(links.callCenter())
    }
    return null
  }
}
